import { call, put, takeLatest } from 'redux-saga/effects';

import {
  FETCH_MODULES_REQUEST,
  ADD_MODULE_REQUEST,
  UPDATE_MODULE_REQUEST,
  DELETE_MODULE_REQUEST,
} from './actionTypes';

import {
  fetchModulesSuccess,
  fetchModulesFailure,
  addModuleSuccess,
  addModuleFailure,
  updateModuleSuccess,
  updateModuleFailure,
  deleteModuleSuccess,
  deleteModuleFailure,
} from './actions';

import axiosInstance from 'pages/Utility/axiosInstance';
import { showSuccess } from 'helpers/notification_helper';

// ============================
// API Calls
// ============================

const fetchModulesApi = async (params) => {
  return await axiosInstance.get('V1/modules', { params });
};

const addModuleApi = async (data) => {
  return await axiosInstance.post('V1/modules', data);
};

const updateModuleApi = async ({ id, data }) => {
  return await axiosInstance.put(`V1/modules/${id}`, data);
};

const deleteModuleApi = async (id) => {
  return await axiosInstance.delete(`V1/modules/${id}`);
};

// ============================
//  Sagas
// ============================

// Fetch Modules
function* fetchModulesSaga(action) {
  try {
    const response = yield call(fetchModulesApi, action.payload);
    yield put(fetchModulesSuccess(response.data));
  } catch (error) {
    yield put(fetchModulesFailure(error.message));
  }
}

// Add Module
function* addModuleSaga(action) {
  try {
    const response = yield call(addModuleApi, action.payload.data);
    console.log(response.data)
    yield put(addModuleSuccess(response.data));
    if (action.payload.callback) action.payload.callback(); 
    showSuccess('Module added successfully!');
  } catch (error) {
    yield put(addModuleFailure(error?.response?.data?.errors || error.message));
  }
}

// Update Module
function* updateModuleSaga(action) {
  try {
    const response = yield call(updateModuleApi, {
      id: action.payload.id,
      data: action.payload.data,
    });
    
    yield put(updateModuleSuccess(response.data));
    if (action.payload.callback) action.payload.callback(); 
    showSuccess(response?.data?.message || 'Module updated successfully!');
  } catch (error) {
    yield put(updateModuleFailure(error?.response?.data?.errors || error.message));
  }
}

// Delete Module
function* deleteModuleSaga(action) {
  try {
    const { data } = yield call(deleteModuleApi, action.payload);
    yield put(deleteModuleSuccess(data));
    showSuccess('Module deleted successfully!');
  } catch (error) {
    yield put(deleteModuleFailure(error.message));
  }
}

// ============================
//  Watcher
// ============================

export default function* moduleSaga() {
  yield takeLatest(FETCH_MODULES_REQUEST, fetchModulesSaga);
  yield takeLatest(ADD_MODULE_REQUEST, addModuleSaga);
  yield takeLatest(UPDATE_MODULE_REQUEST, updateModuleSaga);
  yield takeLatest(DELETE_MODULE_REQUEST, deleteModuleSaga);
}
